import type { BaseItemSchema } from "@memorang/types";
import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import type { LevelIconName } from "../../../icon";
import {
	buildReviewAnswersContext,
	createInitialReviewAnswersState,
	deriveReviewAnswersView,
	toggleReviewAnswersState,
} from "./helpers";
import type { ReviewAnswersAction } from "./types";

type Options = {
	sessionItems: BaseItemSchema[];
	proficiencyIconMap?: Record<string, LevelIconName>;
};

export const useSessionReportReviewAnswersFilters = ({
	sessionItems,
	proficiencyIconMap,
}: Options) => {
	const { t } = useTranslation();
	const context = useMemo(
		() =>
			buildReviewAnswersContext({
				sessionItems,
				proficiencyIconMap,
				t,
			}),
		[sessionItems, proficiencyIconMap, t],
	);
	const [state, setState] = useState(() =>
		createInitialReviewAnswersState(context),
	);

	const toggle = useCallback(
		(action: ReviewAnswersAction) =>
			setState((current) =>
				toggleReviewAnswersState({ context, state: current, action }),
			),
		[context],
	);

	return { view: deriveReviewAnswersView({ context, state }), toggle };
};
